import { useMemo } from 'react';
import { ACTOR } from '../constants/actors';
import { useAppTeams } from './useAppTeams';
export const useTeamMemberCounts = approvers => {
  const hasTeamApprovers = useMemo(() => approvers.some(approver => approver.actor.actorType === ACTOR.TEAM), [approvers]);
  const {
    teamsRecord
  } = useAppTeams({
    enabled: hasTeamApprovers
  });
  return useMemo(() => Object.fromEntries(Object.entries(teamsRecord).map(([id, team]) => {
    var _team$secondaryUserId;
    return [id, new Set([...team.userIds, ...((_team$secondaryUserId = team.secondaryUserIds) !== null && _team$secondaryUserId !== void 0 ? _team$secondaryUserId : [])]).size];
  })), [teamsRecord]);
};